<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @netFn="netFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @useAgainFn="useAgainFn"
      />
      <div class="componentPage">
        <stopTable
          :tableData="tableData"
          v-bind="$attrs"
          :loading="loading"
          @choozeTable="choozeTable"
          @delRowFn="delRowFn"
          @configFn="configFn"
          @editScopeRowFn="editScopeRowFn"
          @useAgainRowFn="useAgainRowFn"
          @detailFn="detailFn"
        />
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
    <!-- 网络参数 -->
    <Net
      :isShow.sync="isShow"
      :title="title"
      :choozeTableData="choozeTableData"
      ref="net"
    />
    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
    <!-- 详情 -->
    <!-- <DetailDialog :isDetailShow.sync="isDetailShow" :title="title" :detailObj="detailObj" :deviceType="deviceType"
  :deviceProperty="deviceProperty" :netObj="netObj" v-bind="$attrs" ref="detailDialog" @changdetail="changdetail" /> -->
    <!-- 配置信息 -->
    <Config
      :isShowConfig.sync="isShowConfig"
      :title="title"
      :rowData="rowData"
      v-bind="$attrs"
      ref="config"
      v-if="isShowConfig"
    />
  </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import qs from 'qs'
import stopTable from './stopTable.vue'
import Net from '../components/VNet.vue'
import EditScope from '../components/EditScope.vue'
import Config from '../modal/ConfigDialog/ConfigDialog.vue'
import {
  gatewayDel,
  gatewayList,
  gatewayUpdateStatus
} from '@/api/modules/gateway.js'
import { shareScope } from '@/api/modules/public.js'
import { deviceListCarrierPreHandle } from '@/pages/equipment/common/preHandle'

export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    stopTable,
    Net,
    EditScope,
    Config
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.gateway_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 2,
          text: 'device.gateway_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 4,
          text: 'public.carrier',
          type: 'input',
          paramsName: 'carrierName',
          isChooze: false
        },
        {
          id: 3,
          text: 'device.mac_address',
          type: 'input',
          paramsName: 'mac',
          isChooze: false
        }
      ],
      SearchForm: {
        scopeName:
          this.$store.state.SchemaTree[0].scene_code === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        name: null,
        type: null,
        mac: null,
        carrierName: null
      },
      total: 0,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 2,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        {
          id: 4,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.reuse',
          method: 'useAgainFn'
        }
      ],
      choozeTableData: [],
      // 网络参数
      isShow: false,
      title: '',
      // 修改范围
      isShowEditShow: false,
      scopeArray: [],
      // 详情
      isDetailShow: false,
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {},
      // 配置
      isShowConfig: false,
      // 把表格的数据也传递过去
      rowData: {}
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
    if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
      this.optareBtn.push({
        id: 3,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.loading = true
      gatewayList(this.SearchForm, 'stop')
        .then(({ result, pageInfo }) => {
          this.tableData = result.map(item => {
            item.carrierList = deviceListCarrierPreHandle(item)
            return item
          })
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        scopeName:
          this.$store.state.SchemaTree[0].scene_code === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        name: null,
        type: null,
        mac: null,
        carrierName: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj =
        this.$store.state.SchemaTree[0].scene_code === 'all_node'
          ? null
          : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },

    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 1
          }

          gatewayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = {
            ids: row.id,
            edited: 1
          }

          gatewayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_gateway_is_not_the_same_customer')
        )
      }
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].scene_id + ''
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 单条修改范围 */
    editScopeRowFn (row) {
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = row.sceneId + ''
        this.$refs.scopedId.dioForm.ids = row.id
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 获取范围 */
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 重新使用 */
    useAgainFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      const query = qs.stringify({
        ids: idList.join(','),
        status: 0
      })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          gatewayUpdateStatus(query, 'use').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条重新使用 */
    useAgainRowFn (row) {
      const query = qs.stringify({
        ids: row.id,
        status: 0
      })
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          gatewayUpdateStatus(query, 'use').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      this.isShowConfig = true
      this.title = $t('public.config_info')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigNet'
      })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('gatewayParam', row.id, row.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  height: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
